import { Location } from "../Models";

export default class BookingSearchCriteria {
    private location: Location;
    private checkInDate: string;
    private checkOutDate: string;
    private email: string|null;
    private phoneNumber: string|null;

    constructor(location:Location, checkInDate:string, checkOutDate:string, email:string|null, phoneNumber:string|null) {
        this.location = location;
        this.checkInDate = checkInDate;
        this.checkOutDate = checkOutDate;
        this.email = email;
        this.phoneNumber = phoneNumber;
    }

    getLocation():Location {
        return this.location;
    }

    getCheckInDate():string {
        return this.checkInDate;
    }

    getCheckOutDate():string {
        return this.checkOutDate;
    }

    getEmail():string|null {
        return this.email;
    }

    getPhoneNumber():string|null {
        return this.phoneNumber;
    }
}